import { ActionButtonProps, ButtonType } from './buttonTypes';
import { BUTTON_TYPES } from './buttonConfig';

const ActionButton = <T = any,>({
    type = 'save' as ButtonType,
    onClick,
    disabled = false,
    className = '',
    text,
    icon,
    size = '',
}: ActionButtonProps<T>) => {
    const config = BUTTON_TYPES[type];
    const buttonText = text || config.text;
    const buttonIcon = icon || config.icon;
    const sizeClass = size ? `btn-${size}` : '';

    return (
        <button
            type="button"
            className={`btn ${className !== '' ? className : config.className} ${sizeClass}`.trim()}
            onClick={() => onClick?.()}
            disabled={disabled}
        >
            <i className={`${buttonIcon} me-2 d-inline-block lh-1`}></i>
            {buttonText}
        </button>
    );
};

export default ActionButton;
